<template>
	<div class="full-layer-bottom-header">
		<div class="container">
			<div class="row align-items-center">
				<MegaMenu />
				<div class="col-lg-9 margin">
					<ul class="bottom-nav g-nav u-d-none-lg">
						<li v-for="category in getCategories" :key="category.id">
							<router-link
								:to="{
									name: 'ProductsByCategory',
									params: {id: category.id, slug : category.category_slug},
								}"
								>{{ category.name }}
							</router-link>
						</li>
					</ul>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import MegaMenu from "./MegaMenu.vue";
	import {mapActions, mapGetters} from "vuex";
	import {ContentLoader} from "vue-content-loader";
	export default {
		components: {MegaMenu, ContentLoader},
		computed: {...mapGetters("cat", ["getCategories", "status"])},
		methods: {},
		mounted() {},
	};
</script>

<style scoped>
	.margin{
		margin-bottom: -1px;
	}
	.hed {
		width: 300px !important;
		left: 350px;
	}
	span {
		z-index: 0;
	}
	li {
		padding: 0px 15px;
	}
	.content-loader {
		display: flex;
		list-style: none;
	}
	ul {
		background-color: #343a40;
		border-radius: 10px 10px 0px 0px;
		width: 80%;
		padding-left: 0px;
		text-align: center;
	}
	li:hover {
		background-color: #b89166;
	}
	li a {
		color: white !important;
	}
</style>
